import { Button, Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";

import useErrors from "hooks/useErrors";
import LabelRequired from "components/utils/LabelRequired";
import DropZoneInput from "components/utils/DropZoneInput";

const ToolDocumentForm = ({
  onSubmit,
  type = "create",
  initialValues,
}) => {
  const [toolDocumentForm, setToolDocumentForm] =
    useState(initialValues);
  const [errors, setErrors] = useState({
    fileName: "",
  });
  const validateErrors = useErrors({
    fileName: "isRequired",
  });

  const onSubmitForm = () => {
    let hasErrors = false;

    Object.entries(toolDocumentForm).forEach((itemForm) => {
      const [name, value] = itemForm;
      const check = !!checkErrors(name, value);
      if (!hasErrors) hasErrors = check;
    });

    if (!toolDocumentForm.fileSrc) {
      toast.error(strings.validations.fileRequired);
      return;
    }

    if (!hasErrors) {
      onSubmit(toolDocumentForm);
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setToolDocumentForm((prevSt) => ({
      ...prevSt,
      [name]: value,
    }));
    checkErrors(name, value);
  };

  const onChangeFile = (file) => {
    setToolDocumentForm((prevSt) => ({
      ...prevSt,
      fileSrc: file,
    }));
  };

  const checkErrors = (name, value) => {
    const errorMessage = validateErrors(name, value);
    if (errorMessage)
      setErrors((prevErr) => ({ ...prevErr, [name]: errorMessage }));
    else setErrors((prevErr) => ({ ...prevErr, [name]: "" }));
    return errorMessage;
  };

  const resetFormValues = () => {
    setErrors({
      fileName: "",
    });
    setToolDocumentForm(initialValues);
  };

  useEffect(() => {
    setToolDocumentForm(initialValues);
  }, [initialValues]);

  return (
    <>
      <Grid rowGap="15px" columnGap="15px" padding="20px">
        <Grid gap="15px" templateColumns={{ base: "1fr" }}>
          <TextField
            name="fileName"
            label={<LabelRequired text={strings.fields.fileName.label} />}
            value={toolDocumentForm.fileName}
            onChange={onChange}
            errorMessage={errors.fileName}
            hasError={!!errors.fileName}
          ></TextField>
          <DropZoneInput
            fileSelected={toolDocumentForm.fileSrc}
            onChange={onChangeFile}
          />
        </Grid>
        <Flex justifyContent="end">
          <Button
            children={strings.fields.buttons.reset}
            onClick={resetFormValues}
          ></Button>
          <Button
            children={
              type === "create"
                ? strings.fields.buttons.create
                : strings.fields.buttons.save
            }
            onClick={onSubmitForm}
            variation="primary"
            isDisabled={Object.values(errors).some((e) => !!e)}
          ></Button>
        </Flex>
      </Grid>
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      fileName: {
        label: "Nombre del Documento",
      },
      fileSrc: {
        label: "Archivo",
      },
      buttons: {
        create: "Crear",
        save: "Guardar",
        reset: "Restablecer",
      },
    },
    validations: {
      fileRequired: "El archivo es requerido",
    },
  },
});

export default ToolDocumentForm;
